<template>
  <div>
    <!--页面标题-->
    <div class="page-title">系统消息</div>
    <!--消息列表-->
    <ul class="info-box">
      <!--列表项-->
      <li
        v-for="(item, index) in messageList"
        :key="index"
        class="content"
        :class="item.hasRead === 1 ? 'active' : ''"
      >
        <!--消息内容-->
        <div class="text">{{ item.message }}</div>
        <!--日期-->
        <div class="date">{{ item.date }}</div>
      </li>
    </ul>
    <!--分页-->
    <el-pagination
      v-show="param.page >= 1"
      @current-change="handleCurrentChange"
      :current-page.sync="param.page"
      :page-size="param.count"
      layout="prev, pager, next, jumper"
      :total="data"
      class="mt-20"
    />
  </div>
</template>

<script>
import API from '@/api';

export default {
  name: 'InformationName',
  data() {
    return {
      param: {
        count: 10,
        page: 0,
        type: '',
      },
      data: 0, // 消息总数
      messageList: [
        /* {
          hasRead: 1,
          message: '消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容',
          date: '2021-11-19 09:10'
        },
        {
          hasRead: 0,
          message: '消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容',
          date: '2021-11-19 09:10'
        },
        {
          hasRead: 0,
          message: '消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容消息内容',
          date: '2021-11-19 09:10'
        } */
      ],
    };
  },
  created() {
    this.getmessage();
  },
  methods: {
    handleCurrentChange(page) {
      this.param.page = page - 1;
      this.getmessage();
    },
    // 获取消息列表
    getmessage() {
      API.message(this.param.page = 1, this.param.count, this.param.type)
        .then((res) => {
          this.data = res.message.data.totalCount;
          this.messageList = res.message.data.list;
          // if (res.message.succes) {
          //   console.log(res)
          //   this.data = res.message.data.totalCount
          //   this.messageList = res.message.data.list
          //   console.log(this.messageList)
          // }
        })
        .catch((mgs) => {
          console.log(mgs);
        });
    },
    //
  },
};
</script>

<style lang="scss" scoped>
// 页面标题
.page-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.info-box {
  //margin: 20px 0;
  padding: 8px 0;
  // 内容
  .content {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    /*line-height: 64px;*/
    white-space: nowrap;
    padding: 20px 30px;
    cursor: pointer;
    background: #fff;

    &:before {
      content: '●';
      font-size: 4px;
      padding-right: 10px;
    }
    &:nth-child(even) {
      background: #fffaed;
    }
    &:hover {
      color: #f7b515;
      white-space: normal;
    }
    &.active {
    }
    // 文本
    .text {
      flex: 1 1 auto;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    // 日期
    .date {
      flex: 0 0 200px;
      text-align: right;
    }
  }
}
</style>
